import React, { Component } from 'react';

class Banner extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    // Actualizado: "Comprometidos con la Responsabilidad Fiscal" → dato real del CV
                    title: 'Más de 20 años fiscalizando recursos públicos',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    // Actualizado: "Liderazgo comprobado en el Servicio Público" → cargo actual
                    title: 'Regidora en la Comisión Permanente de Hacienda',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    // Actualizado: "Dominio de la Ingeniería Económica y Financiera" → mensaje ciudadano
                    title: 'Vigilancia del gasto: que cada peso llegue a tu colonia',
                },
            ]
        }
    }
    render() {
        return (
            <section className="banner pb-80">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content ">
                                <span className="subheading">Transparentando, gestionando y dando resultados para ti.</span>
                                <h1>Marlene Puertas</h1>
                                {/* Agregado: línea de cargo bajo el nombre */}
                                <p className="banner-cargo">Regidora de Mineral de la Reforma · Especialista en Finanzas Públicas y Fiscalización</p>
                                <ul>
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={i}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="banner-img">
                                {/* Actualizado: "booke.jpg" (roto) → "marlene-hero.jpeg" */}
                                <img src="assets/images/banner/marlene-hero.jpeg" alt="Marlene Puertas Ramírez" className="img-fluid"/>
                            </div>
                        </div>
                    </div> 
                </div> 
            </section>
        );
    }
}

export default Banner;
